<template>
  <div>
    <div class="banner"></div>
    <div class="mnews">
      <van-tabs
        :ellipsis="false"
        swipeable
        v-model="activename"
        @change="tabchange"
      >
        <van-tab title="综合新闻" name="综合新闻">
          <div
            style="padding: 3.2vw 4vw; background: rgba(244, 246, 249, 0.5)"
            v-if="activename == '综合新闻'"
          >
            <div
              class="newslist"
              v-for="(i, j) in newslist"
              :key="j"
              @click="checkinfo(i, j)"
              @touchstart="changecolor(j)"
              @touchend="colorstyle = -1"
            >
              <div class="listicon">
                <img :src="i.firstUrl" alt="" class="listimg" />
                <div class="listtime" style="display: flex">
                  {{ i.createTime }}
                </div>
              </div>
              <div class="listcontent">
                <h1
                  class="listtitle"
                  :style="{
                    color: colorstyle == j ? 'rgba(25, 97, 172, 1)' : '#06192D',
                  }"
                >
                  {{ i.title }}
                </h1>
                <p class="listcon">{{ i.summary }}</p>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagesize.total"
                :page-size="pagesize.size"
                @current-change="getnewslist"
                :current-page.sync="pagesize.page"
              >
              </el-pagination>
            </div>
          </div>
        </van-tab>
        <van-tab title="工程动态" name="工程动态">
          <div
            style="padding: 3.2vw 4vw; background: rgba(244, 246, 249, 0.5)"
            v-if="activename == '工程动态'"
          >
            <div
              class="newslist"
              v-for="(i, j) in newslist"
              :key="j"
              @click="checkinfo(i, j)"
              @touchstart="changecolor(j)"
              @touchend="colorstyle = -1"
            >
              <div class="listicon">
                <img :src="i.firstUrl" alt="" class="listimg" />
                <div class="listtime" style="display: flex">
                  {{ i.createTime }}
                </div>
              </div>
              <div class="listcontent">
                <h1
                  class="listtitle"
                  :style="{
                    color: colorstyle == j ? 'rgba(25, 97, 172, 1)' : '#06192D',
                  }"
                >
                  {{ i.title }}
                </h1>
                <p class="listcon">{{ i.summary }}</p>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagesize.total"
                :page-size="pagesize.size"
                @current-change="getnewslist"
                :current-page.sync="pagesize.page"
              >
              </el-pagination>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      colorstyle: -1,
      activename: "newslist",
      newsclicks: "",
      newslist: [
        {
          icon: require("../../assets/image/mnews01.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews02.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews03.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews04.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews05.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews06.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews07.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
        {
          icon: require("../../assets/image/mnews08.png"),
          title: "新闻标题",
          content: "新闻内容",
          time: "2023-08-09",
        },
      ],
      secondnewslist: [],
      pagesize: { page: 1, size: 10, total: 0 },
    };
  },
  mounted() {
    this.getlist("综合新闻");
  },
  methods: {
    getnewslist(e) {
      this.pagesize.page = e;
      this.getlist(this.activename);
    },
    async getlist(e) {
      let data = {
        category: `新闻中心/${e}`,
        current: this.pagesize.page,
        size: this.pagesize.size,
      };
      const res = await this.$http.newslist(data);
      if (res.code == 200) {
        this.newslist = res.data;
        this.pagesize.total = res.total;
      } else {
        // 处理错误情况
        console.log("Error fetching news list:", res.data.msg);
      }
    },
    checkinfo(e) {
      let data = {
        category: `新闻中心/${this.activename}`,
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/mnewsinfo",
        query: data,
      });
    },
    changecolor(e) {
      this.colorstyle = e;
    },
    gotonewinfo() {
      this.$router.push({
        path: "/mnewsinfo",
      });
    },
    tabchange(e) {
      this.activename = e;
      this.getlist(e);
    },
    scrolls(e) {
      // console.log(e.target.scrollLeft);
    },

    turnto(e) {
      window.open(e);
    },
    handleClick(f) {
      this.fathernum = f.index;
      this.activechild = 0;
      for (let i in this.tabslist) {
        if (i == f.index) {
          if (this.tabslist[i].children.length > 0) {
            for (let j in this.tabslist[i].children) {
              if (j == 0) {
                this.senddata = this.tabslist[i].children[j].content;
              }
            }
          } else {
            this.senddata = this.tabslist[i].content;
          }
        }
      }
    },
    newsclik(e) {
      this.newsclicks = e;
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 42.67vw;
  background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mnewstop.png")
    no-repeat;
  /* background-position: 0 0; */
  background-size: 100%;
}

.mnews {
  .newslist {
    .listcontent {
      .listcon {
        font-size: 12px;
        height: 50px;
        pointer-events: none;
        color: rgba(6, 25, 45, 0.68);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }

      .listtitle {
        font-size: 15px;
        color: #000;
        margin-bottom: 0.83vw;
        pointer-events: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 20px;
      }

      flex: 1;
      display: flex;
      flex-direction: column;
      pointer-events: none;
      width: 211px;
    }

    .listicon {
      .listtime {
        position: absolute;
        bottom: 0;
        left: 0;
        pointer-events: none;
        width: 100%;
        height: 28px;
        background: rgba(3, 109, 220, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 14px;
      }

      .listimg {
        width: 100%;
        height: 100%;
        pointer-events: none;
      }

      width: 100px;
      height: 80px;
      position: relative;
      margin-right: 10px;
      pointer-events: none;
    }

    width: 100%;
    height: 104px;
    background: #fff;
    padding: 12px;
    display: flex;
    margin-bottom: 2.67vw;
  }

  width: 100%;
  background-size: 100% 100%;
  background-position: 0 0;
  background: rgba(244, 246, 249, 0.5);
}

#tab-newslist {
  left: 15px;
  top: 7px;
  width: 60px;
  height: 21px;
  opacity: 1;

  font-family: Alibaba PuHuiTi 2;
  font-size: 55px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0em;

  font-feature-settings: "kern" on;
  color: #1961ac;
}

::v-deep .van-tabs__item {
  padding: 0 7px;
  margin-left: 15px;
}

::v-deep .van-tab__pane {
  display: flex !important;
  flex-direction: column;
  gap: 10px;
}

::v-deep .van-tabs__line {
  width: 60px;
  height: 2px;
  border-radius: 4px 4px 0 0;
  background: #1668bc;
  opacity: 1;
  color: #1668bc;
}
.pagination {
  height: unset;
}
::v-deep .el-pagination {
  margin-bottom: 1.33vw;
}
::v-deep .btn-next {
  border: unset;
  width: 6.4vw;
  height: 6.4vw;
}
::v-deep .btn-prev {
  border: unset;
  width: 6.4vw;
  height: 6.4vw;
}
::v-deep .number {
  width: 6.4vw;
  height: 6.4vw;
  min-width: unset !important;
  line-height: 6.4vw;
  border: 1px solid rgba(215, 216, 217, 1);
  border-radius: 4px !important;
  font-size: 3.2vw !important;
  text-align: center;
  color: rgba(6, 25, 45, 0.68) !important;
  font-weight: normal !important;
}
::v-deep .el-pager li.active {
  color: #fff !important;
}
::v-deep .van-tab--active {
  color: #1961ac !important;
  font-size: 4vw;
  // font-size: 4vw;
}
</style>
